import './Navbar.css'
import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi'
import { NavHashLink } from 'react-router-hash-link';

const Navbar = () => {
    const [clicked, setClicked] = useState(false)

    return (
        <nav className='navbar'>
            <div className="nav-logo">
                @foysalBN
            </div>
            <div
                onClick={() => setClicked(!clicked)}
                className="menue-icon" >
                {!clicked ? <FiMenu size={25} />
                    :
                    <FiX size={25} />
                }
            </div>
            <ul className={!clicked ? "nav-list" : "nav-list nav-list-active"}>
                <li className="nav-item">
                    <NavLink to='/' className='nav-link' >Home</NavLink>
                </li>
                <li className="nav-item">
                    <NavHashLink to='#projects' className='nav-link'>Projects</NavHashLink>
                </li>
                <li className="nav-item">
                    <NavLink to='/blogs' className='nav-link' >Blogs</NavLink>
                </li>
                <li className="nav-item">
                    <NavLink to='/about' className='nav-link' >About Me</NavLink>
                </li>
                <li className="nav-item">
                    <NavHashLink to='/#contact-me' className='nav-link contact-btn'>Contact me</NavHashLink>
                </li>
            </ul>

        </nav>
    );
};

export default Navbar;
